var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 2.59961C12.4717 2.59961 13.9797 4.03751 14.1244 5.90234L14.1332 6.08398V6.2002C14.1331 7.24212 13.7296 8.14487 13.0609 8.75781L12.8666 8.93652V8.98047C12.7656 9.06604 12.6353 9.17783 12.4838 9.30957C12.1466 9.60273 11.695 10.0004 11.2035 10.4336C10.2217 11.2989 9.07966 12.3083 8.349 12.9395C8.17258 13.0862 7.89856 13.0865 7.72107 12.9414C6.98886 12.309 5.82568 11.2963 4.8363 10.4316C4.34071 9.99852 3.88886 9.6028 3.55701 9.31152C3.40687 9.17974 3.28741 9.07349 3.19958 8.99609V8.95117L3.02478 8.77539C2.33102 8.08163 1.93304 7.16559 1.93298 6.2002V6.08496C1.98977 4.21111 3.58945 2.66699 5.46716 2.66699C5.74534 2.6671 6.11403 2.76392 6.48181 2.96191C6.83372 3.1514 7.14175 3.41108 7.34412 3.7002C7.64091 4.30642 8.51663 4.29878 8.79919 3.67773C8.96446 3.37509 9.26407 3.10098 9.62537 2.89941C9.99296 2.69441 10.3596 2.59963 10.6 2.59961Z",
    stroke: "#4B5563",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.45b94fdfc9bc00618c95d1708b6024a9.svg";
export { ForwardRef as ReactComponent };